import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function useCatalogData(form, setForm) {
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [modelMeta, setModelMeta] = useState(null);

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data.categories)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!form.category) { setBrands([]); return; }
    api.get(`/brands?category=${encodeURIComponent(form.category)}`)
      .then((r) => setBrands(r.data.brands || []))
      .catch(() => setBrands([]));
  }, [form.category]);

  useEffect(() => {
    const realBrand = form.brand === "__other__" ? form.brand_custom : form.brand;
    if (!form.category || !realBrand) { setModels([]); return; }
    api.get(`/models?category=${encodeURIComponent(form.category)}&brand=${encodeURIComponent(realBrand)}`)
      .then((r) => setModels(r.data.models || []))
      .catch(() => setModels([]));
  }, [form.brand, form.brand_custom, form.category]);

  useEffect(() => {
    setModelMeta(null);
    if (!form.model || form.model === "__other__" || !form.brand || form.brand === "__other__") return;
    api.get(`/model-info?category=${encodeURIComponent(form.category)}&brand=${encodeURIComponent(form.brand)}&model=${encodeURIComponent(form.model)}`)
      .then((r) => {
        if (!r.data.found) return;
        setModelMeta(r.data);
        setForm((p) => {
          const ownedMonths = (parseInt(p.owned_time, 10) || 0) * (p.owned_unit === "years" ? 12 : 1);
          const next = { ...p, original_retail_price: p.original_retail_price || String(r.data.msrp) };
          if (p.purchase_type === "new") {
            next.owned_time = String(r.data.age_months_estimate);
            next.owned_unit = "months";
          } else {
            next.age_at_purchase_time = String(Math.max(0, r.data.age_months_estimate - ownedMonths));
            next.age_at_purchase_unit = "months";
          }
          return next;
        });
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.model, form.brand, form.category]);

  return { categories, brands, models, modelMeta, setModels };
}
